import axios from "../axios"

const articleApi = {
	
}
export default articleApi